import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import SearchablePressList from "../components/algolia/SearchablePressList.jsx";

export default class SearchablePressListModule extends BaseModule {
  init() {
    this.mount = this.el.querySelector("[data-searchable-press-list-mount]");
    if (!this.mount) return;

    this.props = {};
    this.render();
  }

  render() {
    if (!this.mount) return;
    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mount);
    }
    this.reactRoot.render(createElement(SearchablePressList, this.props));
  }

  destroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }
  }
}
